import * as Yup from "yup";
import dayjs from "utils/dayjs";
import { users } from "./users";

export const getOwnerUserValidation = ({ wholeOwnershipPercentage = false }) =>
  users
    .concat(
      Yup.object({
        identifyingId: Yup.string()
          .required("SSN is required")
          .matches(
            /^((?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4})|(\d{9})$/,
            "Enter a valid SSN",
          ),
        title: Yup.string()
          .required("Title is required")
          .notOneOf(["Other"], "Title is required"),
        isOwner: Yup.boolean(),
        ownershipPercentage: Yup.number()
          .transform((value, original) => (original === "" ? undefined : value))
          .typeError("OwnershipPercentageRange")
          .required("Ownership percentage is required")
          .min(25, "OwnershipPercentageRange")
          .max(100, "OwnershipPercentageRange")
          .test(
            "decimals",
            wholeOwnershipPercentage
              ? "OwnershipPercentageWhole"
              : "OwnershipPercentageDecimals",
            (value) =>
              value === undefined ||
              Number(value.toFixed(wholeOwnershipPercentage ? 0 : 2)) === value,
          ),
        birthdate: Yup.date()
          .required("Date of birth is required")
          .typeError("Enter a valid date of birth")
          .test("age", "You must be at least 18 years old", function (value) {
            return value ? dayjs().diff(dayjs(value), "year") >= 18 : false;
          })
          .test("age", "Enter a valid date of birth", function (value) {
            return value ? dayjs().diff(dayjs(value), "year") < 150 : false;
          }),
      }),
    )
    .shape({
      location: Yup.object({ id: Yup.string() }),
    });
